const isProduction = process.env.NODE_ENV === 'production'
const isTest = process.env.NODE_ENV === 'testing'
const hUrl = isProduction ?
  /**
   * 正式环境
   */
  'https://ht.tiangen.top/' :

  /**
   * 测试环境
   */
  'https://httest.tiangen.top/';

  /**
   * 开发环境
   */
  // 'http://localhost:8787/';

export default hUrl;


// WEBPACK FOOTER //
// ./src/utils/url.js